import {Component, EventEmitter, HostListener, Input, OnDestroy, Output,} from '@angular/core';
import {NavigationService} from '../services/nav/navigation.service';
import {UserService} from '../services/user/user.service';
import {OrganizationControllerService, OrganizationMinimalDto, UserDto,} from '@api/utisha-backend';
import {NavMenuItem} from './nav-menu-item';
import {ResponsiveService} from '../services/responsive.service';
import {SidenavService} from '../services/sidenav.service';
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet,} from '@angular/router';
import {S3ImgComponent} from '../aws/s3-img/s3-img.component';
import {IsStudentDirective} from '../student/is-student-directive';
import {StudentCreditsComponent} from '../student/student-credits/student-credits.component';
import {GeneralChatIndicatorComponent} from '../chat/general-chat-indicator/general-chat-indicator.component';
import {TranslatePipe} from '@ngx-translate/core';
import {UtIconComponent} from '../ui/icon/ut-icon.component';
import {UtAvatarComponent} from '../ui/avatar/ut-avatar.component';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [
    S3ImgComponent,
    RouterLinkActive,
    RouterLink,
    IsStudentDirective,
    StudentCreditsComponent,
    GeneralChatIndicatorComponent,
    RouterOutlet,
    TranslatePipe,
    UtIconComponent,
    UtAvatarComponent,
  ],
})
export class NavComponent implements OnDestroy {
  nav: NavigationService;
  user?: UserDto;
  hasExtraContent = false;
  drawerOpen = false;
  @Input() shadow = true;
  @Input() title: string;
  @Input() menuItems: NavMenuItem[] = [];
  @Output() menuToggle = new EventEmitter<void>();
  desktop: boolean;
  mobile: boolean;
  organization: OrganizationMinimalDto;

  private routerSub: Subscription;

  constructor(
    navService: NavigationService,
    private userService: UserService,
    public responsive: ResponsiveService,
    private orgService: OrganizationControllerService,
    public sidenav: SidenavService,
    private activeRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.nav = navService;
    this.userService
      .getUserObservable()
      .subscribe({ next: (user: UserDto | undefined) => (this.user = user) });
    this.responsive.getWindowResize().subscribe(() => this.handleResize());
    this.handleResize();
    orgService
      .getOrganizationMinimal()
      .subscribe((org) => (this.organization = org));

    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.closeDrawer());
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  openDrawer(): void {
    this.drawerOpen = true;
    this.menuToggle.emit();
  }

  closeDrawer(): void {
    if (!this.drawerOpen) return;
    this.drawerOpen = false;
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeDrawer();
  }

  private handleResize(): void {
    this.mobile = this.responsive.isMobile;
    this.desktop = this.responsive.isDesktop;
    if (!this.mobile) {
      this.drawerOpen = false;
    }
  }
}
